/**
 * MatterStatusBadge — premium status indicator for matter status.
 *
 * Design principle: status should be immediately readable, professional,
 * and understated. No garish colors. Legal vocabulary, not startup copy.
 */
import { cn } from '@/lib/utils';
import { matterStatusLabel, matterStatusBadgeClass } from '@/lib/matterStatus';

interface Props {
  status: string;
  className?: string;
}

export function MatterStatusBadge({ status, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold leading-tight tracking-[0.02em]',
        matterStatusBadgeClass(status),
        className,
      )}
    >
      {matterStatusLabel(status)}
    </span>
  );
}
